// extracted by mini-css-extract-plugin
export default {"container":"gG-z","modal":"hG-z","dimensions":"iG-z","brandName":"jG-z","productName":"kG-z","labelValue":"lG-z","recipientEmail":"mG-z","recommendedFit":"nG-z","hiddenField":"oG-z"};